'use client';
import Image from 'next/image';
import Link from 'next/link';

const mediaPartners = [
  {
      src: '/images/startupnews-logo.webp',
      alt: 'startupnews',
      link: 'https://startupnews.fyi/',
    },
  {
    src: "/images/smartmoneymatch-black.webp",
    alt: "SmartMoneyMatch",
    link: "https://www.smartmoneymatch.com/help/media-partnerships",
  },
  {
    src: "/images/transportstake.webp",
    alt: "TransportStake",
    link: "https://www.transportstake.com/",
  },
  {
    src: "/images/publicitymarketplace-colored.webp",
    alt: "Publicity Marketplace",
    link: "https://www.publicitymarketplace.com/en/media-library",
  },
  {
    src: "/images/functionalsourcing-colored.webp",
    alt: "Functional Sourcing",
    link: "https://www.functionalsourcing.com/en/media-library",
  },
  {
    src: "/images/educationstake-colored.webp",
    alt: "EducationStake",
    link: "https://www.educationstake.com/en/media-library",
  },
  {
    src: "/images/matchsdg.webp",
    alt: "MatchSDG",
    link: "https://www.matchsdg.com/en/media-library",
  },
  {
    src: "/images/financialservicesreview.webp",
    alt: "Financial Services Review",
    link: "https://www.financialservicesreview.com/",
  },
  {
    src: "/images/privatebanking.webp",
    alt: "Private Banking",
    link: "https://www.privatebanking.com/",
  },
  {
    src: "/images/techedgeai.webp",
    alt: "TechEdgeAI",
    link: "https://techedgeai.com/",
  },
  {
    src: "/images/gogetgpt.webp",
    alt: "GoGetGPT",
    link: "https://gogetgpt.com/",
  },
  {
    src: "/images/aimojo.webp",
    alt: "AIMojo",
    link: "https://aimojo.io/",
  },
  {
    src: "/images/aipressroom.webp",
    alt: "AI Pressroom",
    link: "https://aipressroom.com/",
  },
  {
    src: "/images/bigdataanalyticsnews.webp",
    alt: "Big Data Analytics News",
    link: "https://bigdataanalyticsnews.com/",
  },
  {
    src: "/images/aiml-events.webp",
    alt: "AI ML Events",
    link: "https://aiml.events/",
  },
  {
    src: "/images/dazeinfo.webp",
    alt: "Dazeinfo",
    link: "https://dazeinfo.com/",
  },
  {
    src: "/images/ciotechoutlook.webp",
    alt: "CIO Tech Outlook",
    link: "https://www.ciotechoutlook.com/",
  },
  {
    src: "/images/worldbusinessoutlook.webp",
    alt: "World Business Outlook",
    link: "https://worldbusinessoutlook.com/",
  },
  {
    src: "/images/bfmtimes.webp",
    alt: "BFM Times",
    link: "https://bfmtimes.com/",
  },
  {
    src: "/images/btcwire.webp",
    alt: "BTCWire",
    link: "https://btcwire.io/",
  },
  {
    src: "/images/zexprwire-logo.webp",
    alt: "ZEX PR Wire",
    link: "https://zexprwire.com/",
  },
  {
    src: "/images/gazetinternational.webp",
    alt: "Gazet International",
    link: "https://gazetinternational.com/",
  },
  {
    src: "/images/keydifference.webp",
    alt: "Key Difference Wire",
    link: "https://keydifference.com/wire/",
  },
  {
    src: "/images/etherpr.webp",
    alt: "Ether PR",
    link: "https://etherpr.com/",
  },
  {
    src: "/images/coinraftar.webp",
    alt: "CoinRaftar",
    link: "https://coinraftar.com/",
  },
  {
    src: "/images/edarabia.webp",
    alt: "Edarabia",
    link: "https://www.edarabia.com/",
  },
  {
    src: "/images/aiedgeinsights.svg",
    alt: "AI Edge Insights",
    link: "http://www.aiedgeinsights.com/",
  },
  {
    src: "/images/techpression.webp",
    alt: "Techpression",
    link: "https://techpression.com/",
  },
  {
    src: "/images/aitoolsnetwork.webp",
    alt: "AI Tools Network",
    link: "https://aitoolsnetwork.com/artificial-intelligence-events/",
  },
];

const MediaPartnersLogoSection = () => {
  return (
    <section data-component-id="src/app/MediaPartnersLogoSection.tsx:155:4" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="155" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22media-partners%22%2C%22className%22%3A%22w-full%20bg-black%20py-10%22%7D" id="media-partners" className="w-full bg-black py-10">
      {/* Heading Center */}
      <h2 data-component-id="src/app/MediaPartnersLogoSection.tsx:157:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="157" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B18px%5D%20sm%3Atext-%5B25px%5D%20md%3Atext-%5B30px%5D%20lg%3Atext-5xl%20font-semibold%20text-white%20mb-12%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-center text-[18px] sm:text-[25px] md:text-[30px] lg:text-5xl font-semibold text-white mb-12">
        Media Partners
      </h2>

      {/* Centered Grid */}
      <div data-component-id="src/app/MediaPartnersLogoSection.tsx:162:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="162" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1240px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20lg%3Agrid-cols-6%20gap-2%22%7D" className="max-w-[1240px] mx-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
        {mediaPartners.map((partner, index) => (
          <a data-component-id="src/app/MediaPartnersLogoSection.tsx:164:10" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="164" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20h-%5B60px%5D%20sm%3Ah-%5B80px%5D%20md%3Ah-%5B80px%5D%20lg%3Ah-%5B90px%5D%20p-2%22%7D"
            key={index}
            href={partner.link}
            target="_blank"
            rel={index === 9 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
            className="flex items-center justify-center h-[60px] sm:h-[80px] md:h-[80px] lg:h-[90px] p-2"
          >
            <Image data-component-id="src/app/MediaPartnersLogoSection.tsx:171:12" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="171" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B220px%5D%20h-%5B130px%5D%20bg-white%20max-h-full%20transition-transform%20duration-200%20hover%3Ascale-105%20rounded-%5B10px%5D%20p-2%22%7D"
              src={partner.src}
              alt={partner.alt}
              width={120}
              height={70}
              // className="object-contain w-[220px] h-[130px] bg-[linear-gradient(40deg,#060606_0%,#000000_70%,_#1B339E_100%)] max-h-full transition-transform duration-200 hover:scale-105 rounded-[10px] p-2"
              className="object-contain w-[220px] h-[130px] bg-white max-h-full transition-transform duration-200 hover:scale-105 rounded-[10px] p-2"
              unoptimized
            />
          </a>
        ))}
      </div>
    </section>
  );
};

export default MediaPartnersLogoSection;
